export default __webpack_public_path__ + "static/media/banco-do-brasil-logo.f5173d68.svg";